import React, { FC, useEffect, useRef } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { AddItem } from '@wix/design-system';
import { useFilePicker } from '@wix/gg-common-lib/hooks';
import { Player } from '@lottiefiles/react-lottie-player';
import animationData from 'assets/lotties/sparkles-loader.json';
import styles from '../CreateProductStep.scss';

type Props = {
  onFilePicked: (file: File | undefined) => void;
  isLoading?: boolean;
};

export const CreateProductStepUpload: FC<Props> = ({ onFilePicked, isLoading }) => {
  const { t } = useTranslation();

  const { openFilePicker } = useFilePicker({ onFilePicked });

  const ref = useRef<Player>(null);

  useEffect(() => {
    if (isLoading) {
      ref.current?.play();
    } else {
      ref.current?.pause();
    }
  }, [isLoading]);

  return (
    <AddItem
      subtitle={t('create-product-step.upload-image.subtitle')}
      onClick={openFilePicker}
      icon={<Player loop ref={ref} className={styles.createProductStepUploadLottie} src={animationData} />}
      disabled={isLoading}
      size="medium"
    >
      {isLoading ? t('create-product-step.upload-image.title.loading') : t('create-product-step.upload-image.title')}
    </AddItem>
  );
};
